import React from 'react';
import { motion } from 'framer-motion';
import Digital from './neuro.png';
import worklife from './worklife.png'

const ProductShowcase = () => {
  return (
    <section className="product-showcase">
      <div className="product-showcase-container">
        <div className="product-showcase-content">
          <motion.div 
            className="product-showcase-text"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <h2 className="product-showcase-title">
              Advanced neurofeedback.<br />Extraordinary results.
            </h2>
            <p className="product-showcase-description">
              Experience real-time brain activity monitoring that adapts to you, helping you achieve optimal mental states for peak performance.
            </p>
          </motion.div>

          <motion.div 
            className="showcase-main"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <img src={worklife} alt="Neurofeedback Technology" className="showcase-main-image" />
            <div className="showcase-features">
              <div className="showcase-feature">
                <h3>Real-time Monitoring</h3>
                <p>Track your brain activity patterns as they happen</p>
              </div>
              <div className="showcase-feature">
                <h3>Dynamic Feedback</h3>
                <p>Receive instant guidance to optimize your mental state</p>
              </div>
              <div className="showcase-feature">
                <h3>Scientific Precision</h3>
                <p>Built on proven neurofeedback principles</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;